module.exports = __webpack_public_path__ + "static/media/aesthetic_inspo.67f6fae9.png";